import './bootstrap';
import './header';
import './contact';
import './authentication';


window.addEventListener('load', () => {
  setTimeout(() => {
    document.querySelector('.anim__wrapper').classList.add('active');
  }, 1000); // 1000ms = 1 segundo
});

jQuery(document).ready(function ($) {

  $('.next-tab').on('click', function () {

    setTimeout(() => {
      const activePanel = $('.ui-tabs-panel:visible');
      const index = activePanel.data('index');
      const footer = document.querySelector('.prefooter');

      console.log('Paso actual:', index);

      if (index >= 2) {
        console.log('👉 Footer especial');
        footer.classList.add('step-3-active');
      } else {
        console.log('👈 Footer normal');
        footer.classList.remove('step-3-active');
      }

    }, 50); // 👈 esperamos a que cambie el tab

  });

});